import './less/sideMenu.less';
import {getWindowWidth} from "../../js/core/Helpers/Helpers";
import menuList from '../menuList/menuList';

const sideMenu = () => {
	let pageContent = document.querySelector('.pageContent');
	let canvasElements = document.getElementsByClassName('canvasElement');
	let sideMenu = document.querySelector('#sideMenu');
	let canvasOpener = document.querySelector('.JS_canvas-opener');
	let closeEvent = new Event('closeOffcanvasSidebar');
	
	let init = () => {
		
		$('#sideMenu .JS_sideMenuItem.active').closest('.JS_sideSubmenu').addClass("opened");
		
		$('.menuList__list__item__link').click(function () {
			$(this).next('.JS_sideSubmenu').first().toggleClass('opened');
		});
		
		let toggleElements = () => {
			if(canvasOpener) {
				if ($(document).scrollTop() > 100) {
					canvasOpener.classList.add('active');
				} else {
					canvasOpener.classList.remove('active');
				}
			}
		};
		
		let openNav = () => {
			[...canvasElements].forEach(element => {
				element.classList.add('offcanvas');
			});
		}
		
		let closeNav = () => {
			[...canvasElements].forEach(element => {
				element.classList.remove('offcanvas');
			});
		}
		
		if(canvasOpener) {
			canvasOpener.addEventListener('click', openNav);
		}
		
		$('.JS_closebtn, #myCanvasNav').click(function (e) {
			e.preventDefault();
			closeNav();
		});
		
		if (getWindowWidth() < 1200) {
			canvasOpener.classList.add('active');
		} else {
			window.addEventListener("scroll", function () {
				toggleElements();
			});
		}
		
		if(sideMenu) {
			sideMenu.addEventListener('closeOffcanvasSidebar', closeNav);
		}
		
	};
	
	return init();
};

const menu = sideMenu();

export default menu;


// WEBPACK FOOTER //
// ./components/sideMenu/sideMenu.js